import { Redirect, Route, Switch } from 'react-router-dom';

import { AccountingFiles } from '../pages/AccountingFiles';
import { EmailConfirmation } from '../pages/Auth/EmailConfirmation';
import { Login } from '../pages/Auth/Login';
import { NewPassword } from '../pages/Auth/NewPassword';
import { PasswordReset } from '../pages/Auth/PasswordReset';
import { Register } from '../pages/Auth/Register';
import { RegisterInvited } from '../pages/Auth/RegisterInvited';
import { Config } from '../pages/Config';
import { Dashboard } from '../pages/Dashboard';
import { DividasTributarias } from '../pages/DividasTributarias';
import { ExtratoBancario } from '../pages/ExtratoBancario';
import { Page404 } from '../pages/Page404';
import { PublicNfePage } from '../pages/PublicNfe';
import { Solicitations } from '../pages/Solicitations';
import { PrivateRoute } from './PrivateRoute';

export const Routes = () => {
  return (
    <Switch>
      <PrivateRoute exact path="/" component={Dashboard} />
      {/* tmp route to fix LABS-520 */}
      <PrivateRoute exact path="/cliente" component={Dashboard} />
      <PrivateRoute exact path="/configuracoes" component={Config} />
      <PrivateRoute exact path="/arquivos" component={AccountingFiles} />
      <PrivateRoute exact path="/solicitacoes" component={Solicitations} />
      <PrivateRoute exact path="/dividas-tributarias" component={DividasTributarias} />
      <PrivateRoute exact path="/extrato-bancario" component={ExtratoBancario} />
      {/* Redirect old /usuarios route to /configuracoes */}
      <Route exact path="/usuarios" render={() => <Redirect to="/configuracoes" />} />
      <Route exact path="/convidado/:apiToken" component={RegisterInvited} />
      {/* Redirect /cadastro//:apiToken to /convidado/:apiToken */}
      <Route
        exact
        path="/cadastro//:apiToken"
        render={({ match }) => (
          <Redirect to={`/convidado/${match.params.apiToken}`} />
        )}
      />
      <Route
        exact
        path="/cadastro/:companyName/:apiToken"
        component={Register}
      />
      <Route exact path="/login" component={Login} />
      <Route exact path="/esqueci-a-senha" component={PasswordReset} />
      <Route exact path="/esqueci-a-senha/:token" component={NewPassword} />
      <Route exact path="/confirmacao-do-email" component={EmailConfirmation} />
      <Route exact path="/solicitar-nfe/:tenantId/:token" component={PublicNfePage} />
      <Route exact path="*" component={Page404} />
    </Switch>
  );
};
